export const TEST_SERVER_URI = 'ibetest.etgcloud.io';
export const SNOWPLOW_COLLECTOR_TEST_ENDPOINT = 'snowplow-collector.dsrtest01.k8s.etgcloud.io';
